(() => {
  if (window.vsHomeRefinements) return;
  window.vsHomeRefinements = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const scrollSections = new Set();
  const photoFrames = new Set();
  const clamp = n => Math.max(0, Math.min(1, n));
  let queued = false;
  function paintScroll() {
    queued = false;
    scrollSections.forEach(section => {
      if (!section.isConnected) { scrollSections.delete(section); return; }
      const visual = section.querySelector('.vsh-retail-visual') || section;
      const box = visual.getBoundingClientRect();
      // Wait until the image is well inside the viewport, then carry the pulse
      // down the image while the visitor scrolls through it.
      const start = innerHeight * .62;
      const travel = Math.max(innerHeight * .5, box.height - innerHeight * .15);
      const progress = Math.max(0, Math.min(1, (start - box.top) / travel));
      section.style.setProperty('--vsh-progress', reduced.matches ? '.7' : progress.toFixed(4));
      section.style.setProperty('--vsh-recolour', reduced.matches ? '0' : clamp((progress - .2) / .65).toFixed(4));
      section.querySelectorAll('[data-vsh-node]').forEach(node => node.classList.toggle('vsh-node-active', reduced.matches || Math.abs(progress - Number(node.dataset.vshNode) / 2) < .23));
    });
  }
  function paintPhotos() {
    photoFrames.forEach(frame => {
      if (!frame.isConnected) { photoFrames.delete(frame); return; }
      const box = frame.getBoundingClientRect();
      frame.style.setProperty('--vsh-photo-progress', reduced.matches ? '.5' : clamp((innerHeight - box.top) / (innerHeight + box.height)).toFixed(4));
    });
  }
  function scheduleScroll() { if (!queued) { queued = true; requestAnimationFrame(() => { paintScroll(); paintPhotos(); }); } }
  function init(scope = document) {
    scope.querySelectorAll('[data-vsh-photo-motion]').forEach(frame => photoFrames.add(frame));
    scope.querySelectorAll('[data-vsh-scroll]').forEach(section => scrollSections.add(section));
    document.querySelectorAll('[id$="__app_grid_PjKL4B"] .slider-content article').forEach(card => card.setAttribute('data-vsh-reveal', ''));
    scope.querySelectorAll('[data-vsh-rail]').forEach(section => {
      if (section.dataset.vshReady) return;
      section.dataset.vshReady = 'true';
      const rail = section.querySelector('.vsh-rail');
      const prev = section.querySelector('[data-vsh-prev]');
      const next = section.querySelector('[data-vsh-next]');
      if (!rail) return;
      const update = () => {
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft >= max - 3;
        const ratio = Math.min(1, rail.clientWidth / rail.scrollWidth);
        section.style.setProperty('--vsh-thumb', `${ratio * 100}%`);
        section.style.setProperty('--vsh-thumb-offset', `${max ? rail.scrollLeft / max * (1 / ratio - 1) * 100 : 0}%`);
      };
      const move = direction => {
        const card = rail.firstElementChild;
        const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap) : rail.clientWidth;
        rail.scrollBy({ left: direction * distance, behavior: reduced.matches ? 'instant' : 'smooth' });
      };
      prev?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
      });
      // Native horizontal wheel/touch scrolling is preserved. Only mouse dragging needs JS.
      let drag = null;
      let suppressClick = false;
      rail.addEventListener('dragstart', event => event.preventDefault());
      rail.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        suppressClick = false;
        drag = { id: event.pointerId, x: event.clientX, left: rail.scrollLeft, moved: false };
      });
      rail.addEventListener('pointermove', event => {
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) < 6) return;
        if (!drag.moved) { drag.moved = true; rail.setPointerCapture(event.pointerId); rail.classList.add('vsh-dragging'); }
        event.preventDefault();
        rail.scrollLeft = drag.left - dx;
      });
      const endDrag = event => {
        if (!drag || event.pointerId !== drag.id) return;
        suppressClick = drag.moved;
        if (rail.hasPointerCapture(drag.id)) rail.releasePointerCapture(drag.id);
        drag = null;
        rail.classList.remove('vsh-dragging');
        update();
      };
      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);
      rail.addEventListener('pointerleave', event => { if (drag && !drag.moved) drag = null; });
      rail.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; } }, true);
      rail.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(rail);
      update();
    });
    scope.querySelectorAll('[id$="__artboard_E96dYP"] img').forEach(image => image.setAttribute('data-vsh-reveal', ''));
    const elements = scope.querySelectorAll('[data-vsh-reveal]');
    if (!reduced.matches && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('vsh-motion-ready');
      if (!observer) observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('vsh-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0, rootMargin: '0px 0px -25% 0px' });
      elements.forEach((element, index) => {
        element.style.setProperty('--vsh-delay', `${Number(element.dataset.vshDelay ?? index % 3 * 90)}ms`);
        observer.observe(element);
      });
    } else elements.forEach(element => element.classList.add('vsh-visible'));
    scheduleScroll();
  }
  window.addEventListener('scroll', scheduleScroll, { passive: true });
  window.addEventListener('resize', scheduleScroll, { passive: true });
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.documentElement.classList.remove('vsh-motion-ready');
    scheduleScroll();
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
})();


